export class FileAux
{
    base64: string | ArrayBuffer;
    tipoArquivo: string;
    nome: string;
    src: string;
}